if (!customElements.get("ac-testimonials")) {
  class AcTestimonials extends HTMLElement {
    constructor() {
      super();
      this._handleItemHover = this._handleItemHover.bind(this);
    }
    connectedCallback() {
      const isMobile = window.innerWidth < 1280;
      this._items = Array.from(this.querySelectorAll(".testimonials__list-item"));
      if (isMobile) {
        const viewport = document.createElement("div");
        viewport.classList.add("flicking-viewport");
        this.firstElementChild.classList.add("flicking-camera");
        viewport.appendChild(this.firstElementChild);
        this.appendChild(viewport);
        this._items.forEach((item) => {
          this._toggleItemActive(item, true);
        });
        this.flicking = new Flicking(viewport, {
          moveType: "snap",
          align: "center",
          bound: true
        });
      } else {
        this._items.forEach((item) => {
          item.addEventListener("mouseenter", this._handleItemHover);
        });
      }
    }
    _toggleItemActive(item, toggleOn) {
      if (toggleOn) {
        const citeContentEl = item.querySelector(".testimonials__cite-content");
        item.style.setProperty("--cite-content-height", citeContentEl.scrollHeight.toString() + "px");
        item.classList.add("testimonials__list-item--active");
      } else {
        item.style.setProperty("--cite-content-height", "0px");
        item.classList.remove("testimonials__list-item--active");
      }
    }
    _handleItemHover(e) {
      const item = e.target;
      this._toggleItemActive(item, true);
      this._items.forEach((otherItem) => {
        if (otherItem !== item) {
          this._toggleItemActive(otherItem, false);
        }
      });
    }
  }
  customElements.define("ac-testimonials", AcTestimonials);
}
